<template>
  <div class='mvp' @click='mvpClick'>
    <a-icon type="plus-circle" v-if="type!=='view' && edit" class="plus" @click='mvpAdd'/>
    <a-icon v-else class='fit'></a-icon>
    <div class="text">
      {{title}}
    </div>
    <a-icon type="caret-down" class='foldIcon' theme="filled" v-show='open' @click='changeOpen'/>
    <a-icon type="caret-right" class='foldIcon' theme="filled" v-show='!open' @click='changeOpen'/>
  </div>
</template>

<script>
import set from '../settings/settings.js'
export default {
  name: 'mvp',
  props: {
    open: {
      type: Boolean
    },
    type: {
      type: String
    },
    edit: {
      type: Boolean
    }
  },
  data () {
    return {
      title: ''
    }
  },
  methods: {
    mvpAdd () {
      this.$event.$emit('childrensAdd', this.type)
    },
    changeOpen () {
      this.$event.$emit('changeOpen', this.type)
    },
    mvpClick (event) {
      if (event.shiftKey) {
        this.changeOpen()
        return false
      }
    }
  },
  mounted () {
    this.title = set[this.type].title
  }
}
</script>

<style lang="less">
.mvp{
  width: 106px;
  height: 32px;
  line-height: 32px;
  background: #fff;
  border-radius: 4px;
  display: flex;
  float: left;
  margin: 4px;
  i{
    cursor: pointer;
    flex-shrink: 0;
    margin: auto 8px auto 0;
    visibility: hidden;
  }
  .plus{
    margin-left: 8px;
    &:hover{
      color: #FC8830;
    }
  }
  .text{
    flex-grow: 1;
  }
  .foldIcon{
    margin-right: 16px;
    visibility: visible;
  }
  .fit{
    width: 20px;
  }
  &:hover{
    i{
      visibility: visible;
    }
  }
}
</style>
